module.exports = __webpack_public_path__ + "img/phone_framework.9eed9baf.png";